// extracted by mini-css-extract-plugin
export default {"monthSelector":"styles_monthSelector__fBIgP","arrowButton":"styles_arrowButton__t05e+","disabled":"styles_disabled__ZcuqC","monthLabel":"styles_monthLabel__DskIo"};